import React, { Component, Fragment } from "react";
import { Button } from "../components/Button";
import { Paging } from "../components/Paging";
import { Table, TableHead, TableBody, Col, HeaderCell } from "../components/Table";
import { LoadingSpinner } from "../components/LoadingSpinner";
import "./SearchResults.css";
import { FormattedMessage } from "react-intl";
import MunicipalityContext from "../MunicipalityContext";

export class SearchResults extends Component {

  static contextType = MunicipalityContext;

  render() {
    const {
      changePage,
      currentPage,
      pageSize,
      results,
      searching,
      searchError,
      sortColumn,
      sortDirection,
      totalRows,
      updateSort,
      locale,
    } = this.props;

    const spinner = (
      <div className='spinnerContainer'>
        <LoadingSpinner />
      </div>
    );
    if (!searching && !results) return "";

    if (searchError) {
      return (
        <div className='searchError'>
          <FormattedMessage id='sprayTesterSearch.searchError' />
        </div>
      );
    }

    const municipalities = this.context;
    const municipalityNames = municipalities.reduce((obj, municipality) => {
      obj[municipality.kuntaKoodi] =
        locale === "fi" ? municipality.kuntaNimi : municipality.kuntaNimiSv;
      return obj;
    }, {});

    const paging = (
      <Paging
        itemsLength={totalRows}
        perPage={pageSize}
        activePage={currentPage}
        changePage={changePage}
      >
        {({ totalPages, activePage, goBack, goForward }) => (
          <div className='paging'>
            <Button link onClick={goBack} disabled={activePage === 0}>
              <FormattedMessage id='common.previous' />
            </Button>
            <div className='pagesCount'>
              {activePage + 1} / {totalPages || 1}
            </div>
            <Button link onClick={goForward} disabled={activePage >= totalPages - 1}>
              <FormattedMessage id='common.next' />
            </Button>
          </div>
        )}
      </Paging>
    );

    const drawResultsHeadingFinished = (
      <div className="resultHeading" aria-live="assertive">
        <FormattedMessage
          id="common.results"
          values={{
            results: <span className="resultCount">{totalRows}</span>,
          }}
        />
      </div>
    );

    const drawResultsHeadingSearching = (
      <div className='resultHeading'>
        <FormattedMessage id='common.searching' />
      </div>
    );

    const generateKey = row => {
      return `${row.nimi}${row.patevyydet}${row.kuntaKoodi}`;
    };

    return (
      <Fragment>
        {searching ? drawResultsHeadingSearching : drawResultsHeadingFinished}
        {paging}
        <Table>
          <TableHead sortColumn={sortColumn} sortDirection={sortDirection} updateSort={updateSort}>
            <HeaderCell name='nimi'>
              <FormattedMessage id='sprayTesterSearch.name' />
            </HeaderCell>
            <HeaderCell name='testaajanTunnus'>
              <FormattedMessage id='sprayTesterSearch.number' />
            </HeaderCell>
            <HeaderCell name='kuntaKoodi'>
              <FormattedMessage id='sprayTesterSearch.municipality' />
            </HeaderCell>
            <HeaderCell name='puhelinnumero'>
              <FormattedMessage id='sprayTesterSearch.phone' />
            </HeaderCell>
            <HeaderCell name='sahkoposti'>
              <FormattedMessage id='sprayTesterSearch.email' />
            </HeaderCell>
            <HeaderCell name='patevyydet'>
              <FormattedMessage id='sprayTesterSearch.competency' />
            </HeaderCell>
          </TableHead>
          {searching ? (
            <tbody>
              <tr>
                <td colSpan='5'>{spinner}</td>
              </tr>
            </tbody>
          ) : (
            <TableBody rows={results}>
              {rows =>
                rows.map(row => (
                  <tr key={generateKey(row)}>
                    <Col label='sprayTesterSearch.name'>{row.nimi}</Col>
                    <Col label='sprayTesterSearch.number'>{row.testaajanTunnus}</Col>
                    <Col label='sprayTesterSearch.municipality'>
                      {municipalityNames[row.kuntaKoodi]}
                    </Col>
                    <Col label='sprayTesterSearch.phone'>{row.puhelinnumero}</Col>
                    <Col label='sprayTesterSearch.email'>{row.sahkoposti}</Col>
                    <Col label='sprayTesterSearch.competency'>
                      {row.patevyydet.includes('RT KH') ?
                        <FormattedMessage id='common.booleanYes' /> : ""}
                    </Col>
                  </tr>
                ))
              }
            </TableBody>
          )}
        </Table>
        {paging}
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/SprayTesterSearch/SearchResults.js